module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "wrap-black text-center"
  }, [_vm._c('div', {
    staticClass: "container"
  }, [(_vm.valid) ? _vm._c('div', [_vm._c('form', {
    staticClass: "form-pub",
    attrs: {
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_vm._m(0), _vm._v(" "), _vm._c('div', {
    staticClass: "form-group"
  }, [_vm._c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.password),
      expression: "credentials.password"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "password",
      "type": "password",
      "placeholder": "Password",
      "autocomplete": "off",
      "required": "required"
    },
    domProps: {
      "value": _vm._s(_vm.credentials.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.credentials.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._c('div', {
    staticClass: "form-group"
  }, [_vm._c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.confirmPassword),
      expression: "credentials.confirmPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "password",
      "type": "password",
      "placeholder": "Confirm Password",
      "autocomplete": "off",
      "required": "required"
    },
    domProps: {
      "value": _vm._s(_vm.credentials.confirmPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.credentials.confirmPassword = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.currentUser.errors) ? _vm._c('div', _vm._l((_vm.currentUser.errors), function(msg) {
    return _vm._c('div', {
      staticClass: "alert alert-contrast alert-danger alert-dismissible",
      attrs: {
        "role": "alert"
      }
    }, [_vm._c('div', {
      staticClass: "message"
    }, [_vm._v(_vm._s(msg))])])
  })) : _vm._e(), _vm._v(" "), _vm._c('div', {
    staticClass: "form-group xs-pt-10"
  }, [_vm._c('button', {
    staticClass: "btn-pub btn-pub-primary btn-pub-borderless fixed-width",
    attrs: {
      "disabled": !_vm.credentials.password || !_vm.credentials.confirmPassword || _vm.saving
    }
  }, [_vm._v(_vm._s(_vm.saving ? 'Please wait...' : 'Submit'))])])])]) : _vm._c('div', [_vm._c('div', {
    staticClass: "panel-body"
  }, [_vm._c('div', {
    staticClass: "alert alert-contrast alert-danger alert-dismissible",
    attrs: {
      "role": "alert"
    }
  }, [_vm._c('div', {
    staticClass: "message"
  }, [_vm._v("Invalid password reset link")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('p', {
    staticClass: "xs-pb-20"
  }, [_vm._v("\n          Reset Password."), _vm._c('br'), _vm._v("\n          Enter a new password below.\n        ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9575a10a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/ResetPassword.vue
// module id = 697
// module chunks = 1